import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

const ReportCountBadge = ({ count }) => {
  if (!count) {
    return null;
  }

  return (
    <Box
      component="span"
      sx={{
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
        color: 'primary.main',
        borderRadius: 0.75,
        minWidth: 18,
        height: 18,
        px: 0.625,
        fontSize: 11,
        fontWeight: 600,
        lineHeight: '18px',
        textAlign: 'center',
        flexShrink: 0,
      }}
    >
      {count}
    </Box>
  );
};

export default ReportCountBadge;
